/**
 * Admin Menu Management Logic
 */
export function initMenus() {
    const $page = $('#page-id');
    const storeUrl = $page.data('store-url');
    const updateUrlBase = $page.data('update-url');

    // Initialize Modal using Bootstrap 5 native API
    const menuModalEl = document.getElementById('modalMenu');
    let menuModal = null;
    if (menuModalEl) {
        menuModal = new window.bootstrap.Modal(menuModalEl);
    }

    // Helper: Open modal in Create mode
    function openCreateModal(parentId = '') {
        $('#formMenu')[0].reset();
        $('#formMenu').data('mode', 'create');
        $('#modalMenuTitle').text('Add Menu Item');
        $('#active').prop('checked', true);
        $('.permission-check').prop('checked', false);

        // Reset Select2 then optionally set parent
        $('#parent_id').val(parentId || '').trigger('change');

        if (menuModal) menuModal.show();
    }

    // Add Menu button (header)
    $(document).on('click', '.btn-add-menu', function () {
        openCreateModal();
    });

    // Add Submenu button (per row in table) — from inline script in view
    $(document).on('click', '.btn-add-submenu', function () {
        const parentId = $(this).data('parent-id');
        openCreateModal(parentId);
        setTimeout(() => {
            $('#modalMenuTitle').text('Add Submenu Item');
        }, 50);
    });

    // Edit Menu button
    $(document).on('click', '.btn-edit-menu', function () {
        const menu = $(this).data('menu');

        $('#formMenu').data('mode', 'edit');
        $('#formMenu').data('edit-id', menu.id);
        $('#modalMenuTitle').text('Edit Menu Item');

        $('#parent_id').val(menu.parent_id || '').trigger('change');
        $('#title').val(menu.title);
        $('#url').val(menu.url);
        $('#icon').val(menu.icon);
        $('#sequence').val(menu.sequence);
        $('#active').prop('checked', menu.active == 1);

        // Reset & set permission checkboxes
        $('.permission-check').prop('checked', false);
        if (menu.permission) {
            const perms = menu.permission.split(',').map(p => p.trim());
            perms.forEach(p => {
                $(`.permission-check[value="${p}"]`).prop('checked', true);
            });
        }

        if (menuModal) menuModal.show();
    });

    // Handle form submit via AJAX
    $(document).on('submit', '#formMenu', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const mode = $(this).data('mode') || 'create';
        const editId = $(this).data('edit-id');

        let url = storeUrl;
        if (mode === 'edit' && editId) {
            url = `${updateUrlBase}/${editId}/update`;
        }

        const csrfName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content');
        const csrfToken = $('meta[name="X-CSRF-TOKEN"]').attr('content');

        const formData = $(this).serialize();

        const $btn = $(this).find('[type="submit"]');
        $btn.prop('disabled', true).text('Menyimpan...');

        $.ajax({
            url: url,
            type: 'POST',
            data: formData + `&${csrfName}=${csrfToken}`,
            success: function (res) {
                if (res.status === 'success') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil!',
                        text: res.message,
                        timer: 1500,
                        showConfirmButton: false,
                    }).then(() => {
                        window.location.reload();
                    });
                    if (menuModal) menuModal.hide();
                } else {
                    Swal.fire('Error', res.message || 'Gagal menyimpan menu', 'error');
                }
            },
            error: function (xhr) {
                const msg = xhr.responseJSON?.message || 'Terjadi kesalahan sistem';
                const errors = xhr.responseJSON?.errors;
                let errDetail = msg;
                if (errors) {
                    errDetail += '<br><ul>' + Object.values(errors).map(e => `<li>${e}</li>`).join('') + '</ul>';
                }
                Swal.fire({ icon: 'error', title: 'Gagal', html: errDetail });
            },
            complete: function () {
                $btn.prop('disabled', false).text('Simpan Menu');
            }
        });
    });

    // NOTE: Delete is handled by global-crud.js via .btn-delete-submit


    // Bulk Delete
    $(document).on('change', '#check-all', function () {
        $('.row-select').prop('checked', $(this).prop('checked'));
        toggleBulkDeleteBtn();
    });

    $(document).on('change', '.row-select', function () {
        toggleBulkDeleteBtn();
    });

    function toggleBulkDeleteBtn() {
        const count = $('.row-select:checked').length;
        $('#btnBulkDelete').toggleClass('d-none', count === 0);
        $('#selectedCount').text(count);
    }

    $('#btnBulkDelete').on('click', function () {
        const ids = $('.row-select:checked').map(function () { return $(this).val(); }).get();
        if (!ids.length) return;

        const bulkDeleteUrl = $page.data('bulk-delete-url') || `${updateUrlBase}/bulk-delete`;
        const csrfName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content');
        const csrfToken = $('meta[name="X-CSRF-TOKEN"]').attr('content');

        Swal.fire({
            title: `Hapus ${ids.length} menu?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
        }).then(result => {
            if (result.isConfirmed) {
                $.ajax({
                    url: bulkDeleteUrl,
                    type: 'POST',
                    data: { ids, [csrfName]: csrfToken },
                    success: () => window.location.reload(),
                    error: (xhr) => Swal.fire('Error', xhr.responseJSON?.message || 'Gagal', 'error')
                });
            }
        });
    });
}
